module.exports = __webpack_public_path__ + "static/media/Fig-3-4.4df87e6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Fig-3-4.png
// module id = 673
// module chunks = 0